import Modal from "components/Modal";
import ModalBody from "components/Modal/ModalBody";
import UserRoadmap from "..";
import ModalFooter from "components/Modal/ModalFooter";
import useTranslation from "hooks/useTranslation";

function RoadmapModal({ setShowRoadmapModal, showRoadmapModal, userName }) {
  const { getTranslation } = useTranslation(["COMMON"]);
  const { t } = getTranslation();

  return (
    <Modal className="roadmap_modal" visible={showRoadmapModal}>
      <ModalBody>
        <UserRoadmap userName={userName} />
      </ModalBody>
      <ModalFooter>
        <div className="modal__container__footer__left">
          <button
            onClick={() => setShowRoadmapModal(false)}
            className="btn btn-tertiary"
            id="closeModal"
          >
            {t("MODAL").CLOSE}
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
}

export default RoadmapModal;
